export const BLOG_TOPICS = [
  "All", "Google Ads", "Meta Ads", "Local Services Ads", "Conversion tracking", "YouTube",
] as const;

export type BlogTopic = (typeof BLOG_TOPICS)[number];

/** Index chips use literal category labels; article recommendation behavior stays separate. */
export function blogIndexTopics(posts: { category: string }[]): string[] {
  const categories = [...new Set(posts.map((post) => post.category))];
  const preferred = ["Local Services Ads", "Google Ads", "Meta Ads", "Conversion Tracking"];
  return ["All", ...preferred.filter((label) => categories.includes(label)),
    ...categories.filter((label) => !preferred.includes(label))];
}

export function matchesBlogIndexTopic(category: string, topic: string): boolean {
  return topic === "All" || category === topic;
}

export function matchesBlogTopic(category: string, topic: BlogTopic) {
  if (topic === "All") return true;
  const label = category.toLowerCase();
  if (topic === "YouTube") return label === "youtube ads";
  if (topic === "Meta Ads") return label === "meta ads" || label === "meta ads case study" || label === "meta ads guide";
  return label === topic.toLowerCase();
}

export function keepReadingPosts<T extends { slug: string; category: string; published_at: string }>(
  posts: T[], current: { slug: string; category: string },
): T[] {
  return posts
    .filter((post) => post.slug !== current.slug && post.category === current.category)
    .sort((a, b) => Date.parse(b.published_at) - Date.parse(a.published_at))
    .slice(0, 3);
}